import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=e61d56c2&scoped=true"
import script from "./ActivityList.vue?vue&type=script&lang=js"
export * from "./ActivityList.vue?vue&type=script&lang=js"
import style0 from "./ActivityList.vue?vue&type=style&index=0&id=e61d56c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61d56c2",
  null
  
)

export default component.exports